module.exports = __webpack_public_path__ + "static/tfk_background-67b4e77efb36e5d8652798133ada9b86.png";